module.exports = __webpack_public_path__ + "static/media/hurricane.05db93d6.svg";